import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Info pagamento',
    payouts: 'Pagamenti',
  },
  form: {
    invoicing_emails: {
      label: 'Invia fatture a',
      placeholder: 'Inserisci la tua email',
    },
    payout_schedule: {
      label: 'Pianificazione pagamenti',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Pagamenti sospesi',
        [PAYOUT_INTERVAL.DAILY]: 'Pagamenti giornalieri',
        [PAYOUT_INTERVAL.WEEKLY]: 'Pagamenti settimanali',
        [PAYOUT_INTERVAL.MONTHLY]: 'Pagamenti mensili',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Ristorante',
    amount: 'Importo',
    cash_amount: 'Importo contante',
    paypal_standalone_amount: 'Importo PayPal',
    period: 'Periodo',
    paid_at: 'Pagato il',
    provider: 'Provider',
    status: 'Stato',
    actions: 'Azioni',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Contante',
    system: 'Sistema',
  },
  buttons: {
    save: 'Salva',
    actions: 'Azioni',
    open_report: 'Apri report',
    open_tracking_url: 'Traccia pagamento',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'In attesa',
    [PAYOUT_STATUSES.processing]: 'In elaborazione',
    [PAYOUT_STATUSES.paid]: 'Pagato',
    [PAYOUT_STATUSES.failed]: 'Fallito',
    undefined: 'Sconosciuto',
    null: 'Sconosciuto',
  },
  toasts: {
    failed_to_load_data: 'Recupero dati fallito',
    successfully_updated: 'Aggiornato con successo',
  },
};
